<script>
	import MediaQuery from "@/assets/components/MediaQuery";
	import { ToastContainer, FlatToast } from "svelte-toasts";
	import RouterView from "@/router/index";
</script>

<section class="col vh100" id="app">
	<RouterView />
	<MediaQuery />
	<ToastContainer placement="bottom-right" let:data>
		<FlatToast {data} />
	</ToastContainer>
</section>
